import sample_1 from './100_19786.jpg';

export const idealImpressions = {
    sample_1,
};
